<script>
import SeoMixin from '~/sites/oknanebodvere/mixins/SeoMixin'

export default {
  extends: SeoMixin,
  methods: {
    getFavicons() {
      return [{ rel: 'icon', type: 'image/x-icon', href: '/favicon/oknadverenamiru-favicon.png' }]
    },
  },
}
</script>
